module.exports = __webpack_public_path__ + "img/e2.587dc70b.png";